import { handleRequest } from '../constant/helpers';

export const getUser = user_oid => handleRequest("post",
	process.env.REACT_APP_LICENSE_API_URL + '/user', {
	user_oid
})